<template>
  <div class="page-container content-430">
    <div v-if="hasGetApi" class="search-wrapper item-box-430">
      <div class="class-form-head">请假明细</div>
      <div class="class-form-content">
        <Form ref="leaveDetails" inline :model="leaveDetails">
          <FormItem label="开班学校：" prop="schoolName">
            {{ leaveDetails.schoolName }}
          </FormItem>
          <FormItem label="学期：" prop="termName">
            {{ leaveDetails.termName }}
          </FormItem>
          <FormItem label="调班课程名称：" prop="classroomName">
            {{ leaveDetails.classroomName }}
          </FormItem>
          <FormItem label="学生姓名：" prop="studentName">
            {{ leaveDetails.studentName }}
          </FormItem>
          <FormItem label="年级班级：" prop="gradeAndClass">
            {{ leaveDetails.gradeName }}{{ leaveDetails.className }}
          </FormItem>
          <FormItem label="请假时间（时间/节次）：" prop="classTime">
            {{ leaveDetails.classTime }}
          </FormItem>
          <FormItem label="请假单创建时间：" prop="leaveTime">
            {{ leaveDetails.leaveTime }}
          </FormItem>
          <FormItem label="请假类型：" prop="leaveType">
            {{ leaveTypeEnum[leaveDetails.leaveType] }}
          </FormItem>
          <FormItem label="请假事由：" prop="leaveDescribe">
            {{ leaveDetails.leaveDescribe }}
          </FormItem>
          <FormItem label="图片：">
            <div v-if="imgList.length > 0" class="img-box">
              <img
                v-for="(item, index) in imgList"
                :key="index"
                :src="`${downloadUrl}?fileId=${item}`"
                alt=""
                @click="handleShowBigImg(index)"
              >
              <div class="img-none-block"></div>
              <div class="img-none-block"></div>
            </div>
            <div v-else class="img-box">--</div>
          </FormItem>
        </Form>
      </div>
      <div class="class-form-head">审批状态</div>
      <div class="class-form-content">
        <Form label-position="right" inline>
          <FormItem label="请假状态：">
            {{ leaveStateEnum[leaveDetails.leaveState] || '-' }}
          </FormItem>
          <FormItem label="是否可退款：">
            {{ isRetMoneyEnum[leaveDetails.isRetMoney] || '-' }}
          </FormItem>
          <FormItem label="节次费用（元）：">
            {{ leaveDetails.isRetMoney === 0 ? '-' : leaveDetails.feeY }}
          </FormItem>

          <FormItem label="退款状态：">
            {{ refundStsEnum[leaveDetails.refundSts] || '-' }}
          </FormItem>
          <FormItem label="审批时间：">
            {{ leaveDetails.reviewTime || '-' }}
          </FormItem>
          <FormItem label="审批人：">
            {{ leaveDetails.reviewTeaherName || '-' }}
          </FormItem>
          <FormItem label="审批备注：">
            {{ leaveDetails.reviewReason || '-' }}
          </FormItem>
        </Form>
      </div>
    </div>
    <div
      v-if="hasGetOperationList"
      class="operation-list search-wrapper item-box-430"
    >
      <div class="class-form-head">操作记录</div>
      <Table
        border
        stripe
        class="operation-table"
        :loading="loadingOperationData"
        :columns="listColumn"
        :data="operationData"
      >
      </Table>
      <Page
        :total="total"
        show-total
        show-sizer
        show-elevator
        :current="pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <ReviewPhoto
      ref="reviewPhoto"
      :pick-index="pickIndex"
      :img-list="imgList"
      @emitUrl="getDownLoadUrl"
    ></ReviewPhoto>
  </div>
</template>
<script>
import eduCenter from '@/request/eduCenter/index.js';
import ReviewPhoto from '@c/ReviewPhoto.vue';
import { leaveTypeEnumList, leaveStateEnumList, refundStsEnumList, isRetMoneyEnumList, changeDictionaries } from '@/utils/dictionary.js';
export default {
  components: {
    ReviewPhoto
  },
  data() {
    const actTypeList = [
      {
        typeName: '新建',
        span: '',
        color: ''
      }, {
        typeName: '请假单状态审批',
        span: '通过',
        color: 'rgb(2, 175, 244)'
      }, {
        typeName: '请假单状态审批',
        span: '驳回',
        color: 'rgb(221, 0, 27)'
      }, {
        typeName: '请假可退款设置',
        span: '是',
        color: 'rgb(2, 175, 244)'
      }, {
        typeName: '请假可退款设置',
        span: '否',
        color: 'rgb(221, 0, 27)'
      }, {
        typeName: '退款',
        span: '',
        color: ''
      }, {
        typeName: '删除请假单',
        span: '',
        color: ''
      }, {
        typeName: '撤销请假单',
        span: '',
        color: ''
      }
    ];
    return {
      leaveId: '', // 请假id
      leaveDetails: {},
      hasGetApi: false, // 是否拿到请假详情
      leaveTypeEnum: changeDictionaries([...leaveTypeEnumList]),
      leaveStateEnum: changeDictionaries([...leaveStateEnumList]),
      isRetMoneyEnum: changeDictionaries([...isRetMoneyEnumList]),
      refundStsEnum: changeDictionaries([...refundStsEnumList]),
      imgList: [], // 图片
      downloadUrl: '',
      pickIndex: 0,
      listColumn: [
        {
          title: '操作类型',
          ket: 'actType',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              actTypeList[params.row.actType - 1].typeName,
              actTypeList[params.row.actType - 1].span ? h('span', {
                style: {
                  color: actTypeList[params.row.actType - 1].color
                }
              }, [`（${actTypeList[params.row.actType - 1].span}）`]) : ''
            ]);
          }
        },
        {
          title: '操作时间',
          key: 'createTime',
          minWidth: 300
        },
        {
          title: '操作人',
          key: 'creatorName',
          minWidth: 300
        }, {
          title: '备注',
          key: 'remark',
          minWidth: 300
        }
      ],
      operationData: [], // 操作数据
      hasGetOperationList: false, // 是否拿到了操作数据
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loadingOperationData: false
    };
  },
  mounted() {
    this.leaveId = this.$route.query.leaveId;
    this.getLeaveFormDetails();
    this.getActionHistoryList();
  },
  methods: {
    getDownLoadUrl(url) {
      this.downloadUrl = url;
    },
    handleShowBigImg(index) {
      this.pickIndex = index;
      this.$nextTick(() => {
        this.$refs.reviewPhoto.open();
      });
    },
    async getLeaveFormDetails() {
      const params = {
        leaveId: this.leaveId // 请假id
      };
      const res = await eduCenter.getLeaveFormDetailsApi(params);
      if (res.status === 200) {
        this.leaveDetails = res.message;
        this.imgList = res.message.fileIds || [];
        this.hasGetApi = true;
      }
    },
    async getActionHistoryList() {
      const params = {
        leaveId: this.leaveId, // 请假id
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.loadingOperationData = true;
      const res = await eduCenter.getLeaveActHistoryApi(params);
      this.loadingOperationData = false;
      if (res.status === 200) {
        this.hasGetOperationList = true;
        this.operationData = res.message.list;
        this.total = +res.message.total;
      }
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.getActionHistoryList();
    },
    handlePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageNum === 1 && this.getActionHistoryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.class-form-head {
  font-weight: 700;
  font-size: 16px;
}
.class-form-content {
  padding-top: 16px;
}
.class-form-content /deep/.ivu-form-item-label {
  color: #999;
  text-align: right;
}

.class-form-content /deep/.ivu-form-item {
  width: 30%;
}
.operation-table {
  margin-top: 30px;
}
.img-box {
  width: 620px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  img {
    width: 190px;
    height: 190px;
    margin-top: 16px;
  }
  .img-none-block {
    width: 190px;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
